import ErrorPage from "../Components/ErrorPage";

function Error() {
    return (
        <ErrorPage />
    );
}

export default Error;